import { z } from "zod"

export const SearchSchema = z.object({
  id: z.string().optional(),
  subjectId: z.string().optional(),
  status: z.enum(["all", "pass", "fail"]).optional(),
})
